import { z } from 'zod';

import { emailSchema } from '@web/utils';

export const forgotPasswordSchema = z.object({
  email: emailSchema,
  invite_code: z.string().optional(),
});

export type ForgotPasswordSchema = z.infer<typeof forgotPasswordSchema>;
